(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* if (scrollTop >= this.currentScrollTop && scrollTop > this.headerBounds.bottom) { */
      if (scrollTop >= 20) {
        this.header.classList.add('scrolled-past-header');
        
        /* $('.product-search').removeClass("active"); */

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {


        if (!document.querySelector('.mega-menu').hasAttribute('open')) { // Check if sub-menu is open
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
          console.log('remove fired');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  document.addEventListener('DOMContentLoaded', function () {
  // Function to calculate and set the height inline for the SVG element
  function setSvgHeightInline() {
    const logoBigElement = document.querySelector('.innovation-header__logo--big');
    const svgElement = logoBigElement.querySelector('svg');
    
    if (svgElement) {
      const height = svgElement.clientHeight;
      logoBigElement.style.height = height + 'px';
    }
  }

  // Set SVG height inline on page load
  setSvgHeightInline();

  // Recalculate and set SVG height inline on window resize
  window.addEventListener('resize', setSvgHeightInline);
});



const headermenu = document.querySelector('.mega-menu');
const header = document.querySelector('.header');
const headerSticky = document.querySelector('.shopify-section-header-sticky');
const body = document.body;

if (headermenu) {
  headermenu.addEventListener('click', function(event) {
    // Prevent body overflow and toggle classes when menu is clicked
    headerSticky.classList.add('scrolled-past-header');
    header.classList.toggle('menu-background');
    body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';
    console.log('menu clicked');
    
    // Stop the event from propagating to the document
    event.stopPropagation();
  });

  // Listen for clicks on the document
  document.addEventListener('click', function() {
    // Remove the 'scrolled-past-header' class and reset body overflow when clicking outside the menu
    headerSticky.classList.remove('scrolled-past-header');
    header.classList.remove('menu-background');
    body.style.overflow = 'auto';
  });
}


    $("#login-btn").click(function() {
      $(this).addClass("active");
      $("#logout-btn").removeClass("active");
      $("#login-tab").show();
      $("#logout-tab").hide();
    });

    $("#logout-btn").click(function() {
      $(this).addClass("active");
      $("#login-btn").removeClass("active");
      $("#logout-tab").show();
      $("#login-tab").hide();
    });
    
    $('.button-popup-close').click(function() {
      $('.header-popup-modal').removeClass("active");
    });

    $('.header-account-login').click(function() {
      $('.header-popup-modal').toggleClass("active");

      $('#Details-menu-drawer-container').removeClass("menu-opening");
      $('#Details-menu-drawer-container').removeAttr('open');

      $('.sort-filter').removeClass("active");
      $('.product-search').removeClass("active");
      const listWrapper = document.querySelector('.disclosure__list-wrapper'); // Select the list wrapper
      listWrapper.setAttribute('hidden', true);
    });


   $(".header__search-text").click(function(event) {
    event.preventDefault(); // Prevent default action
    event.stopPropagation(); // Stop event propagation

    $(".product-search").toggleClass("active");
    $('.sort-filter').removeClass("active");

    $('#Details-menu-drawer-container').removeClass("menu-opening");
    $('#Details-menu-drawer-container').removeAttr('open');

    /* $(".section-header").addClass("scrolled-past-header"); */

    $('.header-popup-modal').removeClass("active");
    const listWrapper = document.querySelector('.disclosure__list-wrapper'); // Select the list wrapper
    listWrapper.setAttribute('hidden', true);
  });


  $('.disclosure__button').click(function() {
    $('.header-popup-modal').removeClass("active");
    $('.product-search').removeClass("active");
    $('.sort-filter').removeClass("active");
  });

    $("button.close-btn").click(function() {
      $(".product-search").removeClass("active");
   });

    $('a.header__icon--cart').click(function() {
      $('.header-popup-modal').removeClass("active");
      $('.product-search').removeClass("active");
      $('.sort-filter').removeClass("active");
      const listWrapper = document.querySelector('.disclosure__list-wrapper'); // Select the list wrapper
      listWrapper.setAttribute('hidden', true);

      $('#Details-menu-drawer-container').removeClass("menu-opening");
    $('#Details-menu-drawer-container').removeAttr('open');
    });





  } catch(e) { console.error(e); }
})();
})();
